/*
 * sample of ways to extend and customize JS from a per project perspective
 */

 // catching an event
 // sample: catching when something has been added to add-cart
 // outcome: change add to cart button to say 'gotcha' and change success message
 // to test: uncomment below, grunt and add something to your cart
 // $('[data-bq="add-cart"]').on('bq.ajaxAction.processDone', function() {
 //    var el = $(this);
 //        //this = the element that event was triggered on, for ajax-action
 //        //it is element that the ajax-action plugin is attached to
 //    var $plugin = el.data('bq.ajaxAction');
 //        //you have access to the plugin code using jquery data
 //        //with this you could call internal method
 //    $plugin._notify('success', 'changed the success message after the fact!');

 //    //let update the text..
 //    el.text('gotcha');
 // });


 //**************************************************************************//

 // overriding an existing plugin function
 // sample: when using typeahead, we will change the behavoir of something clicked
 // outcome: we will catch when an option was clicked
 //          and instead of going to that page we will take the URL it was
 //          supposed to goto and replace the logo with that url text
 // to test: unccomment below, grunt and use typeahead, click on a result

 // // if we need access to the orig method we could save to a variable for later use
 // bq.typeAheadOrigFunction = bq.typeahead.prototype.catchEventSelected;

 // bq.typeahead.prototype.catchEventSelected = function(e, data) {
 //    //here we could call the origonal method like so:
 //    //bq.typeAheadOrigFunction.call(e, data);

 //    var link = data.link;
 //    var logo = $('.topbar-logo');

 //    logo.text(data.link);
 // };
